import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import { TableExplorer } from "./components/TableExplorer";
import { TypeManager } from "@/components/TypeManager";
import { CodeManager } from "@/components/CodeManager";
import { SearchResolve } from "@/components/SearchResolve";
import { DataQuality } from "@/components/DataQuality";
import { ImportExport } from "@/components/ImportExport";
import { AuditLog } from "@/components/AuditLog";
import { AIConsole } from "@/components/AIConsole";
import { Settings } from "@/components/Settings";
import NotFound from "@/pages/not-found";
import { useEffect } from "react";
// Removed automatic reset/seed on app load to preserve data across reloads

function Router() {
  return (
    <Layout>
      <Switch>
        {/* <Route path="/" component={Home} /> */}
        <Route path="/" component={TableExplorer} />
        {/* <Route path="/table" component={TableExplorer} /> */}
        <Route path="/types" component={TypeManager} />
        {/* <Route path="/codes" component={CodeManager} /> */}
        <Route path="/search" component={SearchResolve} />
        <Route path="/quality" component={DataQuality} />
        <Route path="/import" component={ImportExport} />
        <Route path="/audit" component={AuditLog} />
        <Route path="/ai" component={AIConsole} />
        <Route path="/settings" component={Settings} />
        <Route component={NotFound} />
      </Switch>
    </Layout>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Router />
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
